// Cliente HTTP mínimo para /api/v1. A UI nunca calcula status/score/carga
// (I9, T3 — SPEC-UX §9 "proibido") — sempre consome o valor pronto da API.
const BASE_URL = '/api/v1';

export interface ErroApi {
  codigo: string;
  detalhes?: unknown;
}

export class ErroRequisicao extends Error {
  constructor(
    public status: number,
    public erro: ErroApi,
  ) {
    super(erro.codigo);
  }
}

async function requisitar<T>(caminho: string, opcoes: RequestInit = {}): Promise<T> {
  const resposta = await fetch(`${BASE_URL}${caminho}`, {
    ...opcoes,
    headers: { 'Content-Type': 'application/json', ...opcoes.headers },
  });

  if (!resposta.ok) {
    const corpo = await resposta.json().catch(() => ({ error: { code: 'INTERNAL' } }));
    throw new ErroRequisicao(resposta.status, { codigo: corpo.error?.code ?? 'INTERNAL', detalhes: corpo.error?.details });
  }

  if (resposta.status === 204) return undefined as T;
  return resposta.json();
}

export const api = {
  get: <T>(caminho: string) => requisitar<T>(caminho),
  post: <T>(caminho: string, corpo?: unknown) => requisitar<T>(caminho, { method: 'POST', body: corpo ? JSON.stringify(corpo) : undefined }),
  delete: <T>(caminho: string) => requisitar<T>(caminho, { method: 'DELETE' }),
};
